{
    "ALERTING": {
        "DELAY": "Delay",
        "CHECKBOX_HELP": "When the event occurs, you will receive an e-mail after the set delay time.",
        "FAULT": "Fault",
        "ONLINE_STATUS": "Online-State",
        "OTHER_USERS": "Other Users"
    }
}
